export const JPG_PNG_PDF_FILE_TYPES = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'application/pdf',
];

export const JPG_PNG_PDF_EXTENSIONS = [
  '.jpg',
  '.jpeg',
  '.png',
  '.pdf',
];

export const EXCEL_FILE_TYPES = [
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel.sheet.macroEnabled.12',
];

export const EXCEL_EXTENSIONS = [
  '.xls',
  '.xlsx',
  '.xlsm',
];